
import {api} from "../../services";
import Swal from "sweetalert2";
import $ from "jquery";

// 
const notifications = {
  state: {
    pagination: {
      page: 0,
      data: [], 
      total: 0, 
    },
    count: 0,
    notification: {
      data: {},
    },
  },
    getters: {},
    mutations: {
        SET_NOTIFICATIONS(state, payload) {
            state.pagination = payload
        },
        SET_NOTIFICATIONS_COUNT(state, payload) {
            state.count = payload
        },
        SET_NOTIFICATION(state, payload) {
            state.notification = payload
        },
    },
    actions: {
       async getNotifications( context ) {
      try {
        const page = context.state.pagination.page + 1;
        const response = await api.get(`/notifications?page=${page}`); 
        if ( response.data && response.data.data.length > 0 ) {
            context.state.pagination.data.push(...response.data.data)
            context.state.pagination.page = page;
            context.state.pagination.total = response.data.total
        }
        
        // const notifications = Array.isArray(response.data) ? response.data : response.data.data;

        // context.commit("SET_NOTIFICATIONS", {
        //   data: notifications, 
        //   total: notifications.length,
        // });
      } catch (error) {
        console.error("Erro ao buscar notificações", error);
      }
    },
        getNotificationsCount(context) {
            api.post('/notifications/count').then(response => {
                context.commit("SET_NOTIFICATIONS_COUNT", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        async updateNotification({ dispatch }, payload) {
          try {
            await api.put(`/notifications/${payload.id}`, payload);
            dispatch("getNotifications");
          } catch (error) {
            if (error.response?.status === 401) {
              this.dispatch("logoutUser");
            } else {
              Swal.fire(
                `${this.getters.getTranslations("expression_406")}`,
                `${error.response?.data?.message || "Erro desconhecido"}`,
                "warning"
              );
            }
          }
        },
        deleteNotification(context, payload) {
            api.delete(`/notifications/${payload.id}`).then(() => {
                Swal.fire(
                    `${ context.rootGetters.getTranslations('expression_946') }`,
                    `${ context.rootGetters.getTranslations('expression_947') }`,
                    'success'
                )
                 context.dispatch("getNotifications");  
                  context.dispatch("getNotificationsCount");   
              $('#notificationModal').modal('hide');
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
      deleteAllNotifications(context) {
            api.delete(`/notifications/all`).then(() => {
                Swal.fire(
                    `${ context.rootGetters.getTranslations('expression_906') }`,
                    `${ context.rootGetters.getTranslations('expression_948') }`,
                    'success'
                )
              
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
    },
}
export default notifications;
